import { useState } from 'react';
import { Accordion } from 'components/Accordion';
import { SMSStatistic as SMSStatisticType } from 'types/sms.type';
import styles from '../Statistic/Statistic.module.scss';

export const SMSStatistic = ({ smsStats }: { smsStats?: SMSStatisticType }) => {
    const [isAccordionOpen, setIsAccordionOpen] = useState(true);

    const {
        pending,
        queued,
        overDue,
        sending,
        sent,
        delivered,
        failed,
        retrying,
        // undelivered,
        // replied,
        // carrierFiltered,
        // invalidNumber,
        total,
    } = smsStats || {
        pending: 0,
        queued: 0,
        overDue: 0,
        sending: 0,
        sent: 0,
        delivered: 0,
        failed: 0,
        retrying: 0,
        // undelivered: 0,
        // replied: 0,
        // carrierFiltered: 0,
        // invalidNumber: 0,
        total: 0,
    };

    return (
        <div className={styles.callStatistics}>
            <Accordion
                isOpen={isAccordionOpen}
                onToggle={() => setIsAccordionOpen(!isAccordionOpen)}
                header={
                    <div className={styles.totalCallsLabel}>
                        <span>SMS status overview:</span>
                        <span> {total}</span>
                    </div>
                }
                className={styles.accordion}
            >
                <div className={styles.statsCardsGrid}>
                    {/* Queued/Pending Card */}
                    <div className={`${styles.statCard} ${styles.pendingCard}`}>
                        <div className={styles.statCardHeader}>
                            <div className={styles.statLabel}>Queued/Pending</div>
                            <div className={styles.statValue}>{queued + pending + overDue}</div>
                        </div>
                        <div className={styles.statNotes}>
                            <div className={styles.statNote}>
                                <span className={styles.noteLabel}>Pending:</span>
                                <span className={styles.noteValue}>{pending}</span>
                            </div>
                            <div className={styles.statNote}>
                                <span className={styles.noteLabel}>Queued:</span>
                                <span className={styles.noteValue}>{queued}</span>
                            </div>
                            <div className={styles.statNote}>
                                <span className={styles.noteLabel}>Overdue:</span>
                                <span className={styles.noteValue}>{overDue}</span>
                            </div>
                        </div>
                    </div>

                    {/* Failed Card */}
                    <div className={`${styles.statCard} ${styles.unableCard}`}>
                        <div className={styles.statCardHeader}>
                            <div className={styles.statLabel}>Failed/Issues</div>
                            <div className={styles.statValue}>{failed}</div>
                        </div>
                        <div className={styles.statNotes}>
                            <div className={styles.statNote}>
                                <span className={styles.noteLabel}>Failed:</span>
                                <span className={styles.noteValue}>{failed}</span>
                            </div>
                            {/* <div className={styles.statNote}>
                                <span className={styles.noteLabel}>Undelivered:</span>
                                <span className={styles.noteValue}>{undelivered}</span>
                            </div>
                            <div className={styles.statNote}>
                                <span className={styles.noteLabel}>Carrier Filtered:</span>
                                <span className={styles.noteValue}>{carrierFiltered}</span>
                            </div>
                            <div className={styles.statNote}>
                                <span className={styles.noteLabel}>Invalid Number:</span>
                                <span className={styles.noteValue}>{invalidNumber}</span>
                            </div> */}
                        </div>
                    </div>

                    {/* Sending Card */}
                    <div className={`${styles.statCard} ${styles.inProgressCard}`}>
                        <div className={styles.statCardHeader}>
                            <div className={styles.statLabel}>Sending</div>
                            <div className={styles.statValue}>{sending}</div>
                        </div>
                        <div className={styles.statNotes}>
                            <div className={styles.statNote}>
                                <span className={styles.noteLabel}>In Progress:</span>
                                <span className={styles.noteValue}>{sending}</span>
                            </div>
                            <div className={styles.statNote}>
                                <span className={styles.noteLabel}>Retrying:</span>
                                <span className={styles.noteValue}>{retrying}</span>
                            </div>
                        </div>
                    </div>

                    {/* Sent Card */}
                    <div className={`${styles.statCard} ${styles.contactedCard}`}>
                        <div className={styles.statCardHeader}>
                            <div className={styles.statLabel}>Sent</div>
                            <div className={styles.statValue}>{sent}</div>
                        </div>
                        <div className={styles.statNotes}>
                            <div className={styles.statNote}>
                                <span className={styles.noteLabel}>Sent to Carrier:</span>
                                <span className={styles.noteValue}>{sent}</span>
                            </div>
                        </div>
                    </div>

                    {/* Delivered Card */}
                    <div className={`${styles.statCard} ${styles.transferCard}`}>
                        <div className={styles.statCardHeader}>
                            <div className={styles.statLabel}>Delivered</div>
                            <div className={styles.statValue}>{delivered}</div>
                        </div>
                        <div className={styles.statNotes}>
                            <div className={styles.statNote}>
                                <span className={styles.noteLabel}>Confirmed Delivered:</span>
                                <span className={styles.noteValue}>{delivered}</span>
                            </div>
                        </div>
                    </div>

                    {/* Replied Card */}
                    {/* <div className={`${styles.statCard} ${styles.transferCard}`}>
                        <div className={styles.statCardHeader}>
                            <div className={styles.statLabel}>Replied</div>
                            <div className={styles.statValue}>{replied}</div>
                        </div>
                        <div className={styles.statNotes}>
                            <div className={styles.statNote}>
                                <span className={styles.noteLabel}>Responses:</span>
                                <span className={styles.noteValue}>{replied}</span>
                            </div>
                        </div>
                    </div> */}
                </div>
            </Accordion>
        </div>
    );
};
